import React from 'react';
import logo from './logo.svg';
import logoSad from './logoSad.svg';
import './App.css';
import CounterApp from './components/CounterApp';

// functional component
function App() {

  return (

    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <CounterApp title="Counter App" />
      </header>
    </div>
  );
}



export default App;
